import { render, staticRenderFns } from "./CreateEditItemVuetify.vue?vue&type=template&id=08963e8a&scoped=true"
import script from "./CreateEditItemVuetify.vue?vue&type=script&lang=js"
export * from "./CreateEditItemVuetify.vue?vue&type=script&lang=js"
import style0 from "./CreateEditItemVuetify.vue?vue&type=style&index=0&id=08963e8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08963e8a",
  null
  
)

export default component.exports